var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4836 12.8128V19.935C22.4836 21.0396 21.5882 21.935 20.4836 21.935H7.06429C5.95972 21.935 5.0643 21.0396 5.0643 19.935V12.8128M8.87478 10.7757C8.87478 12.1286 7.77806 13.2253 6.42518 13.2253C5.15882 13.2253 4.1169 12.2644 3.98882 11.0319C3.97121 10.8624 3.99735 10.6923 4.04035 10.5274L5.21861 6.01078C5.44835 5.13012 6.24371 4.51562 7.15384 4.51562H20.3941C21.3042 4.51562 22.0996 5.13012 22.3293 6.01078L23.5076 10.5274C23.5506 10.6923 23.5767 10.8624 23.5591 11.0319C23.431 12.2644 22.3891 13.2253 21.1228 13.2253C19.7699 13.2253 18.6732 12.1286 18.6732 10.7757M8.87478 10.7757C8.87478 12.1286 9.9715 13.2253 11.3244 13.2253C12.6773 13.2253 13.774 12.1286 13.774 10.7757M8.87478 10.7757L9.41913 4.51562M13.774 10.7757C13.774 12.1286 14.8707 13.2253 16.2236 13.2253C17.5764 13.2253 18.6732 12.1286 18.6732 10.7757M13.774 10.7757V4.51562M18.6732 10.7757L18.1288 4.51562",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore0);
export default __webpack_public_path__ + "static/media/store0.0fe5abae05ba4c90b470589622871c4d.svg";
export { ForwardRef as ReactComponent };